import script from "./BindErrorModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BindErrorModal.vue?vue&type=script&lang=ts&setup=true"

import "./BindErrorModal.vue?vue&type=style&index=0&id=119f8130&lang=scss"

const __exports__ = script;

export default __exports__